export const iconFontAwesomeMovingTruckRampBox = (
	<i className="fa-solid fa-truck-ramp-box"></i>
);
